import { render, staticRenderFns } from "./associated-enterprise.vue?vue&type=template&id=661dbc4e&"
import script from "./associated-enterprise.vue?vue&type=script&lang=js&"
export * from "./associated-enterprise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports